import { Component } from '@angular/core';


@Component({
	selector: 'devo-commitments-tab-1-part',
	standalone: true,
	templateUrl: './devo-commitments-tab-1.part.html',
	styleUrls: [`./devo-commitments-tab-1.part.scss`],
})
export class DevoCommitmentsTab1Part {
}
